const ReceiveMoneyIcon = () => {
  return (
    <svg fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.33325 14.3333C6.33325 12.8606 7.52716 11.6667 8.99992 11.6667H22.9999C24.4727 11.6667 25.6666 12.8606 25.6666 14.3333V23C25.6666 24.4728 24.4727 25.6667 22.9999 25.6667H8.99992C7.52716 25.6667 6.33325 24.4728 6.33325 23V14.3333Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M19 18.6667C19 20.3235 17.6569 21.6667 16 21.6667C14.3431 21.6667 13 20.3235 13 18.6667C13 17.0098 14.3431 15.6667 16 15.6667C17.6569 15.6667 19 17.0098 19 18.6667Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M10.3333 6.33333V8.33333"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M16 6.33333V8.33333"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M21.6667 6.33333V8.33333"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

export default ReceiveMoneyIcon
